import React from 'react';

import { HelpCircleIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const TOOLTIP_MESSAGE =
  'Displayed metrics are a sample, not a complete record. To ensure an event will be traced, add HTTP header Trace: true when sending the event.';

export default function EventDebuggerSamplingTooltip() {
  return (
    <WithTooltip show title={TOOLTIP_MESSAGE}>
      <HelpCircleIcon fontSize="small" color="secondary" />
    </WithTooltip>
  );
}
